namespace GeniuzPOS.InitialData {
    export interface PsShopGroupRow {
        Id?: number;
        ShopGroupId?: string;
        ShopGroupName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ShopGroupFullName?: string;
    }

    export namespace PsShopGroupRow {
        export const idProperty = 'ShopGroupId';
        export const nameProperty = 'ShopGroupFullName';
        export const localTextPrefix = 'InitialData.PsShopGroup';
        export const lookupKey = 'InitialData.PsShopGroup';

        export function getLookup(): Q.Lookup<PsShopGroupRow> {
            return Q.getLookup<PsShopGroupRow>('InitialData.PsShopGroup');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:ร้านค้าและคลัง:ร้านค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShopGroupId = "ShopGroupId",
            ShopGroupName = "ShopGroupName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ShopGroupFullName = "ShopGroupFullName"
        }
    }
}
